import icon from './svg/Reading';
import { createIconComp } from './Core/createIconComp';

export const ReadingIcon = createIconComp({ icon });
